import React from "react";
import { createContext } from "react";

const NavigationContext = createContext({
  navigateHome: () => {},
  disableHome: false,
  setDisableHome: () => {},
});

export default NavigationContext;
